import { formatInTimeZone } from "date-fns-tz";
import { parseISO } from "date-fns";

const UK_TZ = "Europe/London";

/**
 * Format a date/ISO string in UK timezone (Europe/London — handles GMT/BST automatically).
 * @param {string|Date} d - ISO date string or Date object
 * @param {string} fmt - date-fns format string (default: "dd MMM yyyy, HH:mm")
 * @returns {string} formatted date in UK timezone, or "-" if invalid
 */
export function fmtUK(d, fmt = "dd MMM yyyy, HH:mm") {
  if (!d) return "-";
  try {
    const date = typeof d === "string" ? parseISO(d) : d;
    return formatInTimeZone(date, UK_TZ, fmt);
  } catch {
    return typeof d === "string" ? d : "-";
  }
}

/**
 * Short format: "dd MMM yy" in UK timezone
 */
export function fmtUKShort(d) {
  return fmtUK(d, "dd MMM yy");
}

/**
 * Full format with seconds: "dd MMM yyyy, HH:mm:ss" in UK timezone
 */
export function fmtUKFull(d) {
  return fmtUK(d, "dd MMM yyyy, HH:mm:ss");
}
